<style lang="scss" scoped>


</style>

<template>
    <input ref="litepicker" class="form-control" :class="{'bg-white': !disabled}" placeholder="Bitte Datum wählen" readonly :disabled="disabled"> 
</template>

<script>

import Litepicker from 'litepicker';

export default {
    name: 'DatePickerInput',
    props: {
        date: {
            type: String,
            default: null
        },
        endDate: {
            type: String,
            default: null
        },
        minDate: {
            type: String,
            default: null
        },
        maxDate: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            picker: null
        }
    },
    methods: {
        initLitepicker: function () {       
            let self = this;
            
            this.picker = new Litepicker({
                element: this.$refs.litepicker,
                format: "DD.MM.YYYY",
                autoRefresh: true,
                startDate: this.date,
                endDate: this.endDate,
                minDate: this.minDate,
                maxDate: this.maxDate,
                lang: "de-DE",
                buttonText: {
                    "apply": "Apply",
                    "cancel": "Cancel",
                    "previousMonth": "&laquo;",
                    "nextMonth": "&#187;",
                    "reset": "&larrhk;"
                }
            });
           
            // eslint-disable-next-line no-unused-vars
            this.picker.on('selected', function (date1, date2) {
                //self.date = date1.format("YYYY-MM-DD");
                self.$emit('update:date', date1.format("YYYY-MM-DD"));
            })
        }
    },    
    created: function () {
        //this.date = this.startDate;
    },
    mounted: function () {
        this.initLitepicker();
    },
    watch: {
        date: function (new_value, old_value) {
            if (new_value !==  old_value) {
                this.picker.setOptions({
                    startDate: this.date
                });
            }
        },
        endDate: function (new_value, old_value) {
            if (new_value !==  old_value) {
                this.picker.setOptions({
                    endDate: this.endDate
                });
            }
        },
        minDate: function (new_value, old_value) {
            if (new_value !==  old_value) {
                this.picker.setOptions({
                    minDate: this.minDate
                });
            }
        },
        maxDate: function (new_value, old_value) {
            if (new_value !==  old_value) {
                this.picker.setOptions({
                    maxDate: this.maxDate
                });
            }
        }
    } 
}
</script>